<template>
  <div class="user_list_page">
    <!-- 加载中提示 -->
    <a-spin v-if="!isAppNamesLoaded" tip="加载中..." style="display: block; text-align: center; margin-top: 100px;">
      <a-icon type="loading" style="font-size: 24px" />
    </a-spin>

    <!-- 数据加载完成后显示表格 -->
    <business-group v-else ref="businessGroup" :tableConfig="{ ...tableConfig }" :formConfig="{ ...formConfig }"
      :formValues="dynamicFormValues">
      <!-- 表格上方操作按钮 -->
      <template slot="tableAction">
        <div style="display: flex; justify-content: space-between; align-items: center;">
          <div style="display: flex; align-items: center;">
            <a-select v-model="currentAppName" @change="handleAppNameChange" placeholder="请选择appName"
              style="width: 300px;">
              <a-select-option v-for="item in appNames" :key="item.name" :value="item.name">
                {{ item.displayName || item.name }}
              </a-select-option>
            </a-select>
          </div>
          <a-button type="primary" @click="add">
            <a-icon type="plus" />
            新增
          </a-button>
        </div>
      </template>

      <template slot="action" slot-scope="record">
        <a-space>
          <a-button type="link" @click="edit(record)">编辑</a-button>
          <!-- <a-button type="link" @click="del(record)">删除</a-button> -->
        </a-space>
      </template>
    </business-group>

    <!-- 新增/编辑弹窗 -->
    <a-modal :visible="visible" :title="title" @ok="submitForm" @cancel="resetForm" :maskClosable="false" width="600px">
      <a-form-model ref="ruleForm" :model="ruleForm" :rules="rules" :label-col="{ span: 6 }"
        :wrapper-col="{ span: 16 }">
        <a-form-model-item label="软件名" prop="name">
          <a-select v-model="ruleForm.name" placeholder="请选择软件名" :disabled="!isAdd">
            <a-select-option v-for="item in appNames" :key="item.name" :value="item.name">
              {{ item.displayName || item.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item label="功能描述" prop="description">
          <a-textarea v-model="ruleForm.description" placeholder="请输入功能描述" :rows="4" />
        </a-form-model-item>

        <a-form-model-item label="安装包上传" prop="content">
          <!-- 上传控件区域 -->
          <div>
            <a-upload name="file" :before-upload="beforeUpload" :remove="removeFile" :file-list="fileList"
              :disabled="upLoading">
              <a-button v-if="fileList.length === 0 && !upLoading">
                <a-icon type="upload" /> 选择文件
              </a-button>
              <div v-if="upLoading" class="upload-loading">
                <a-spin :tip="'上传中... ' + process" />
              </div>
            </a-upload>
          </div>
          <!-- 当前文件信息（仅在编辑模式且有文件时显示） -->
          <div v-if="ruleForm.content && !isAdd && fileList.length === 0" class="current-file-info">
            当前文件：<a :href="ruleForm.content" target="_blank">{{ getCurrentFileName(ruleForm.content) }}</a>
          </div>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import businessGroup from "@/components/business/businessGroup";
import { tips, confirm } from "@/utils/util";
import { multipartUpload } from "@/utils/Oss";
import {
  getById,
  addAppName,
  updateAppName,
  deleteAppName,
  getAppNames
} from "@/api/index";
import { formatToStr } from "@/utils/dateUtils";

export default {
  name: "app-version",
  components: {
    businessGroup
  },
  data() {
    return {
      currentAppName: '', // 当前选择的appName
      appNames: [], // appName列表
      isAppNamesLoaded: false, // appName是否已加载完成
      visible: false,
      title: '',
      isAdd: true,
      upLoading: false,
      fileList: [],
      ruleForm: {
        id: '',
        name: '',
        description: '',
        content: ''
      },
      rules: {
        name: [
          { required: true, message: '请选择软件名', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '请上传安装包' }
        ]
      },
      tableConfig: {
        url: "bluetoothlight/web/system-config/page",
        rowKey: "id",
        columns: [
          {
            title: "软件名",
            dataIndex: "chineseName",
            key: "chineseName",
            align: "center"
          },
          {
            title: "配置名",
            dataIndex: "name",
            key: "name",
            align: "center"
          },
          {
            title: "功能描述",
            dataIndex: "description",
            key: "description",
            align: "center"
          },
          {
            title: "当前版本安装包下载路径",
            dataIndex: "content",
            key: "content",
            align: "left"
          },
          {
            title: "上次更新时间",
            dataIndex: "updateTime",
            key: "updateTime",
            align: "center",
            customRender: (text) => text ? formatToStr(text, "YYYY-MM-DD HH:mm:ss") : '-'
          },
          {
            title: "操作",
            align: "center",
            width: 100,
            scopedSlots: { customRender: "action" }
          }
        ],
        rowKey: "id"
      },
      formConfig: {
        timeShow: false,
        formShow: false,
        hideHeader: true
      },
      formValues: {} // 查询参数
    };
  },
  computed: {
    // 动态生成表单查询参数
    dynamicFormValues() {
      const values = { ...this.formValues };
      // 如果选择了appName，添加到查询参数中
      if (this.currentAppName) {
        values.name = this.currentAppName;
      }
      return values;
    }
  },
  created() {
    // 初始化加载appName列表
    this.loadAppNames();
  },
  methods: {
    // 步骤1：加载appName拉框数据
    async loadAppNames() {
      try {
        const response = await getAppNames();
        if (response?.resultData && Array.isArray(response.resultData)) {
          // 将返回的对象数组转换为下拉框所需格式
          // name作为值，chineseName作为显示名称
          this.appNames = response.resultData.map(item => ({
            name: item.name,
            displayName: item.chineseName || item.name
          }));

          // 步骤2：设置默认选中第一个appName（获取第一个默认值）
          // 如果当前选中的appName不在列表中，或者没有选中任何项，则选中第一个
          if (this.appNames.length > 0) {
            const isCurrentValid = this.appNames.some(item => item.name === this.currentAppName);
            if (!this.currentAppName || !isCurrentValid) {
              this.currentAppName = this.appNames[0].name;
            }
          } else {
            // 如果没有可用的appName，清空当前选择
            this.currentAppName = '';
          }
        }
      } catch (error) {
        console.error('获取appName列表失败:', error);
        tips(this, false, '获取appName列表失败');
      } finally {
        // 步骤3：标记加载完成，触发business-group组件渲染
        // business-group组件会在其created钩子中自动调用getData，使用currentAppName和分页参数请求数据
        this.isAppNamesLoaded = true;
      }
    },

    // 获取下载页面地址（从后端接口获取）
    getDownloadPageUrl(record) {
      const currentProduct = this.appNames.find(item => item.name === this.currentAppName);
      const url = currentProduct?.downloadUrl || '';
      return url ? `<a href="${url}" target="_blank">点击打开</a>` : '-';
    },

    // 切换appName时，重新加载列表数据
    handleAppNameChange() {
      // 使用$nextTick确保响应式更新完成后才刷新数据
      this.$nextTick(() => {
        if (this.$refs.businessGroup) {
          this.$refs.businessGroup.current = 1;
          this.$refs.businessGroup.getData();
        }
      });
    },

    // 新增
    add() {
      this.isAdd = true;
      this.title = `新增`;
      this.ruleForm = {
        id: '',
        name: '',
        description: '',
        content: ''
      };
      this.fileList = [];
      this.visible = true;
    },

    // 编辑
    async edit(record) {
      this.isAdd = false;
      this.title = `编辑${this.currentAppName}`;

      try {
        const response = await getById(record.id);
        this.ruleForm = {
          id: response?.resultData?.id || record.id,
          name: response?.resultData?.name || record.name,
          description: response?.resultData?.description || record.description,
          content: response?.resultData?.content || record.content
        };
        this.fileList = [];
        this.visible = true;
      } catch (error) {
        console.error('获取版本详情失败:', error);
        tips(this, false, '获取版本详情失败');
      }
    },

    // 删除
    del(record) {
      const payload = {
        okBack: async () => {
          try {
            await deleteAppName(record.id);
            tips(this, true, '删除成功');
            // 刷新下拉框数据和表格数据
            await this.loadAppNames();
            this.$refs.businessGroup && this.$refs.businessGroup.getData();
          } catch (error) {
            console.error('删除失败:', error);
            tips(this, false, '删除失败');
          }
        },
        title: `确认删除版本 ${record.name}？`
      };
      confirm(this, payload);
    },

    // 提交表单
    submitForm() {
      this.$refs.ruleForm.validate(async (valid) => {
        if (!valid) {
          return false;
        }

        try {
          const data = {
            ...this.ruleForm
          };

          // 新增时不需要id字段
          if (this.isAdd) {
            delete data.id;
            await addAppName(data);
            tips(this, true, '新增成功');
          } else {
            await updateAppName(data);
            tips(this, true, '更新成功');
          }

          this.visible = false;
          // 刷新下拉框数据和表格数据
          await this.loadAppNames();
          this.$refs.businessGroup.getData();
        } catch (error) {
          console.error('保存失败:', error);
          tips(this, false, this.isAdd ? '新增失败' : '更新失败');
        }
      });
    },

    // 重置表单
    resetForm() {
      this.visible = false;
      this.$refs.ruleForm && this.$refs.ruleForm.resetFields();
      this.fileList = [];
    },

    // 文件上传前处理（不进行格式校验，由用户负责）
    beforeUpload(file) {
      this.upLoading = true;
      this.uploadFileToOss(file);
      return false;
    },

    // 上传文件到OSS
    async uploadFileToOss(file) {
      try {
        const res = await multipartUpload(
          file.name,
          file,
          null,
          `neewer_support/${this.currentAppName.toLowerCase()}`,
          (p) => {
            this.process = Math.ceil(p * 100) + "%";
          }
        );

        this.ruleForm.content = res.url;
        this.fileList = [{
          uid: '-1',
          name: file.name,
          status: 'done',
          url: res.url
        }];

        tips(this, true, '上传成功');
        
        // 清除content字段的校验错误
        this.$nextTick(() => {
          if (this.$refs.ruleForm) {
            this.$refs.ruleForm.clearValidate('content');
          }
        });
      } catch (error) {
        console.error('上传失败:', error);
        tips(this, false, '上传失败');
      } finally {
        this.upLoading = false;
      }
    },

    // 移除文件
    removeFile() {
      this.fileList = [];
      this.ruleForm.content = '';
    },

    // 获取当前文件名
    getCurrentFileName(url) {
      if (!url) return '';
      const parts = url.split('/');
      return parts[parts.length - 1];
    }
  }
};
</script>

<style lang="less" scoped>
.user_list_page {
  .list_button {
    width: 80px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    border: none;
    color: #fff;
    font-size: 12px;
    border-radius: 5px;
    margin-right: 10px;
  }

  // 拖动句柄样式
  :deep(.drag-handle) {
    cursor: move;
    color: #999;
    font-size: 16px;

    &:hover {
      color: #1890ff;
    }
  }

  // 拖动时的样式
  :deep(.sortable-ghost) {
    opacity: 0.4;
    background-color: #f0f0f0;
  }

  :deep(.sortable-drag) {
    cursor: move;
  }

  // 上传加载状态样式
  .upload-loading {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
    border: 1px dashed #d9d9d9;
    border-radius: 4px;
    background-color: #fafafa;
  }

  // 当前文件信息样式
  .current-file-info {
    padding: 8px 12px;
    background-color: #f5f5f5;
    border-radius: 4px;
    color: #666;
  }

  // 无文件提示样式
  .no-file-tip {
    padding: 8px 12px;
    color: #999;
    font-style: italic;
  }
}
</style>
